export default {
  label: 'Cookie consent',
  body: "We use essential cookies to make the site work. With your consent, we'd also use analytics to improve it.",
  policy: 'Cookie policy',
  customize: 'Customize',
  essentialOnly: 'Essential only',
  acceptAll: 'Accept all',
};
